import {UtilitiesService} from "./utilities.service";
import {Injectable} from "@angular/core";

@Injectable()
export class NewuserService {

    private _jobRequest: any;
    prospectId: any = null;
    prospect = {};
    vehicleId: any = null;
    vehicle = {};
    scheduledTime: any = null;
    bookingHours: any = null;
    locationId: any = null;
    location = {};
    promoCode: any = null;
    services: any[] = [];
    sharedLocation = false;
    quote = {};
    private _preselectedServices: any = [];
    private _selectedServices: any = [];
    private _optimized = false;
    private _rightNow = false;

    constructor(private utilitiesService: UtilitiesService) { }

    getProspectId() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("prospectId"));
        } catch (e) {
            return null;
        }
    }

    setProspectId(id: any) {
        try {
            this.utilitiesService.setLocal("prospectId", JSON.stringify(id));
        } catch (e) {
            // do nothing
        }
    }

    getProspect() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("prospect"));
        } catch (e) {
            return null;
        }
    }

    setProspect(prospect: any) {
        try {
            this.utilitiesService.setLocal("prospect", JSON.stringify(prospect));
        } catch (e) {
            // do nothing
        }
    }

    getVehicleId() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("vehicleId"));
        } catch (e) {
            return null;
        }
    }

    setVehicleId(id: any) {
        try {
            this.utilitiesService.setLocal("vehicleId", JSON.stringify(id));
        } catch (e) {
            // do nothing
        }
    }

    getVehicle() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("vehicle"));
        } catch (e) {
            return null;
        }
    }

    setVehicle(vehicle: any) {
        try {
            this.utilitiesService.setLocal("vehicle", JSON.stringify(vehicle));
        } catch (e) {
            // do nothing
        }
    }

    getServices() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("services"));
        } catch (e) {
            return null;
        }
    }

    setServices(services: any) {
        try {
            this.utilitiesService.setLocal("services", JSON.stringify(services));
        } catch (e) {
            // do nothing
        }
    }

    getScheduledTime() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("scheduledTime"));
        } catch (e) {
            return null;
        }
    }

    setScheduledTime(scheduledTime: any) {
        try {
            this.utilitiesService.setLocal("scheduledTime", JSON.stringify(scheduledTime));
        } catch (e) {
            // do nothing
        }
    }

    getBookingHours() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("bookingHours"));
        } catch (e) {
            return null;
        }
    }

    setBookingHours(bookingHours: any) {
        try {
            this.utilitiesService.setLocal("bookingHours", JSON.stringify(bookingHours));
        } catch (e) {
            // do nothing
        }
    }

    getLocationId() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("locationId"));
        } catch (e) {
            return null;
        }
    }

    setLocationId(id: any) {
        try {
            this.utilitiesService.setLocal("locationId", JSON.stringify(id));
        } catch (e) {
            // do nothing
        }
    }

    getLocation() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("location"));
        } catch (e) {
            return null;
        }
    }

    setLocation(location: any) {
        try {
            this.utilitiesService.setLocal("location", JSON.stringify(location));
        } catch (e) {
            // do nothing
        }
    }

    getPromoCodes() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("promoCodes"));
        } catch (e) {
            return [];
        }
    }

    setPromoCodes(promoCode: any) {
        try {
            this.utilitiesService.setLocal("promoCodes", JSON.stringify(promoCode));
        } catch (e) {
            // do nothing
        }
    }

    getSharedLocation() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("sharedLocation"));
        } catch (e) {
            return false;
        }
    }

    setSharedLocation(sharedLocationName: any) {
        try {
            this.utilitiesService.setLocal("sharedLocation", JSON.stringify(sharedLocationName));
        } catch (e) {
            // do nothing
        }
    }

    getQuote() {
        try {
            return JSON.parse(this.utilitiesService.getLocal("quote"));
        } catch (e) {
            return null;
        }
    }

    setQuote(quote: any) {
        try {
            this.utilitiesService.setLocal("quote", JSON.stringify(quote));
        } catch (e) {
            // do nothing
        }
    }

    get jobRequest(): any {
        return this._jobRequest;
    }

    set jobRequest(value: any) {
        this._jobRequest = value;
    }

    get preselectedServices(): any {
        return this._preselectedServices;
    }

    set preselectedServices(value: any) {
        this._preselectedServices = value;
    }

    get selectedServices(): any {
        return this._selectedServices;
    }

    set selectedServices(value: any) {
        this._selectedServices = value;
    }

    get optimized(): boolean {
        return this._optimized;
    }

    set optimized(value: boolean) {
        this._optimized = value;
    }

    get rightNow(): boolean {
        return this._rightNow;
    }

    set rightNow(value: boolean) {
        this._rightNow = value;
    }

    resetAll() {
        this.setProspectId(null);
        this.utilitiesService.removeLocal("prospect");
        this.setVehicleId(null);
        this.setVehicle({});
        this.setServices({});
        this.setScheduledTime(null);
        this.setBookingHours(null);
        this.setLocationId(null);
        this.setLocation({});
        this.setQuote({});

        this._selectedServices = [];
        this._optimized = false;
        this._rightNow = false;

        // don't wipe out preselected services, shared location, and optimized

    } // resetAll()

}
